import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TradeState } from '../../../../../_shared/types/trade';
import StyledNumberOfBids from './Styles';

const NumberOfBids = ({ numberOfBids, tradeState, isSelling }) => {
  if (isSelling && tradeState === TradeState.pending) {
    return null;
  }

  return (
    <StyledNumberOfBids
      isPending={tradeState === TradeState.pending}
      data-testid="bid-counter"
      className="notranslate"
    >
      <b>
        <FormattedMessage
          id="vdp.bid.numberOfBids"
          values={{
            numberOfBids
          }}
        />
      </b>
    </StyledNumberOfBids>
  );
};

export default NumberOfBids;
